var Handlebars = require("../../../node_modules/.pnpm/handlebars@4.7.9_patch_hash=53ad8d748fa2ca3a7a0502c46f2ed1236eef8162efec84c06849dc83ad9e28e9/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <a href=\""
    + alias2(alias1(lookupProperty(blockParams[0][0],"url"), depth0))
    + "\" target=\"_blank\" rel=\"noopener noreferrer\">\n            zulip/"
    + alias2(alias1(lookupProperty(blockParams[0][0],"name"), depth0))
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(data,"last"),{"name":"unless","hash":{},"fn":container.program(1, data, 0, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":6,"column":31},"end":{"line":6,"column":61}}})) != null ? stack1 : "")
    + "\n        </a>\n";
},"1":function(container,depth0,helpers,partials,data) {
    return ", ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, alias1=container.strict, alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<p class=\"contributor-count\">\n    "
    + alias3(alias2(alias1(depth0, "contributor_count", {"start":{"line":2,"column":6},"end":{"line":2,"column":23}} ), depth0))
    + " contributors\n    ("
    + alias3(alias2(alias1(depth0, "hundred_plus_contributor_count", {"start":{"line":3,"column":7},"end":{"line":3,"column":37}} ), depth0))
    + " with 100+ commits) to\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(depth0,"repos"),{"name":"each","hash":{},"fn":container.program(0, data, 1, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":4,"column":4},"end":{"line":8,"column":13}}})) != null ? stack1 : "")
    + "</p>\n";
},"useData":true,"useBlockParams":true});